import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetokonkandarshancab() {



const cardData =
{
  keyword: 'Pune to Konkan Darshan Cabs',
  heading: 'Lotus Cab: Pune to Konkan Darshan Cabs',

  headingDescription: 'Lotus Cab offers professionally managed Pune to Konkan Darshan Cabs for safe, scenic, and comfortable coastal travel. The Konkan region is famous for its pristine beaches, ancient temples, sea forts, and traditional Konkani culture. Our cab service is ideal for families, pilgrimage groups, and coastal vacation travelers. We provide AC sedan and spacious SUV vehicles prepared for long-distance ghat and coastal roads. Our drivers are experienced with Konkan routes and ensure smooth driving through winding highways. With transparent pricing and flexible multi-day packages, we make your Konkan Darshan journey relaxed and memorable.',

  top: 'Top Places to Visit in Konkan with Lotus Cab',

  "topPlaces": [
    {
      "title": "Ganpatipule Temple",
      "description": "Ganpatipule Temple is a sacred pilgrimage destination dedicated to Lord Ganesha. Located along the Arabian Sea coastline, it offers a rare combination of spiritual peace and scenic beauty. Devotees visit throughout the year for darshan and aarti. The temple beach area provides a calm atmosphere for families. It remains one of the most important stops in Konkan Darshan tours."
    },
    {
      "title": "Ratnagiri Beach",
      "description": "Ratnagiri Beach is known for its wide shoreline and mesmerizing sunset views. Visitors enjoy peaceful walks along the sandy coast. The beach reflects Konkan’s natural charm and simplicity. It is ideal for relaxation and photography. Many travelers plan overnight stays in this area."
    },
    {
      "title": "Tarkarli Beach",
      "description": "Tarkarli Beach is famous for its crystal-clear waters and water sports activities. Tourists enjoy scuba diving and snorkeling here. The beach provides a peaceful coastal environment. It is ideal for family vacations and group tours. Fresh seafood adds to the overall travel experience."
    },
    {
      "title": "Sindhudurg Fort",
      "description": "Sindhudurg Fort is a historic sea fort built by Chhatrapati Shivaji Maharaj. The fort stands in the Arabian Sea and represents Maratha naval strength. Visitors reach the fort by boat. It offers panoramic sea views. The fort is a major highlight of Konkan coastal tours."
    },
    {
      "title": "Harihareshwar Temple",
      "description": "Harihareshwar Temple is an ancient Shiva temple located near the sea. Devotees combine temple visits with beach relaxation. The temple offers a peaceful and spiritual environment. It is surrounded by scenic coastal beauty. Many pilgrimage tours include this sacred destination."
    }
  ],

  "services": [
    {
      "name": "Pune to Konkan Darshan Cabs",
      "description": "Lotus Cab provides reliable Pune to Konkan Darshan Cabs for multi-day coastal and temple tours. Our vehicles are air-conditioned and suitable for long-distance travel. Drivers are experienced with Konkan ghat roads and coastal highways. We offer flexible pickup timing from anywhere in Pune. Transparent pricing ensures no hidden charges. The service is ideal for families and pilgrimage groups."
    },
    {
      "name": "Konkan Darshan Cab Package from Pune",
      "description": "Our Konkan Darshan package covers temples, beaches, and heritage sites. Customers can choose customized 2–4 day travel plans. Vehicles provide comfortable seating and luggage space. Drivers assist with route coordination and sightseeing guidance. Clear fare structure is provided before booking. Smooth and scenic journey guaranteed."
    },
    {
      "name": "Pune to Ganpatipule Cab",
      "description": "Dedicated cab service to Ganpatipule Temple with timely arrival planning. Drivers ensure safe highway driving. AC sedan and SUV options are available. One-way and round-trip bookings supported. Ideal for temple visits and family trips. Transparent and affordable pricing offered."
    },
    {
      "name": "Pune to Ratnagiri Taxi",
      "description": "Comfortable taxi service to Ratnagiri with experienced coastal drivers. Vehicles are prepared for long-distance road travel. Flexible departure timing available. Suitable for beach vacations and family outings. Affordable pricing maintained. Safe and reliable service ensured."
    },
    {
      "name": "Luxury Cab for Konkan Tour",
      "description": "Premium luxury cab options for comfortable coastal journeys. Plush seating enhances long-distance travel comfort. Ideal for corporate and VIP travelers. Drivers maintain punctual service. Clean and sanitized interiors provided. Relaxed and stress-free trip experience."
    }
  ],

  "tableData": [
    ["Pune to Konkan Darshan Cabs", "Konkan Darshan Cab Package from Pune"],
    ["Pune to Ganpatipule Cab", "Pune to Ratnagiri Taxi"],
    ["Pune to Tarkarli Cab Service", "Luxury Cab for Konkan Tour"],
    ["SUV Taxi Pune to Konkan", "Affordable Konkan Darshan Cab Pune"],
    ["Online Konkan Darshan Cab Booking", "Best Konkan Tour Cab Service Pune"]
  ],

  "whychoose": [
  {
    "WhyChooseheading": "Experienced Konkan Route Drivers",
    "WhyChoosedescription": "Our drivers are highly experienced with Konkan coastal highways and ghat sections. They are trained to handle winding hill roads and monsoon travel conditions safely. Route familiarity helps avoid unnecessary delays. They also guide travelers with sightseeing coordination. Passenger safety and comfort remain our highest priority. Every journey is managed professionally from start to finish."
  },
  {
    "WhyChooseheading": "Customized Konkan Darshan Packages",
    "WhyChoosedescription": "We offer flexible and fully customizable Konkan Darshan cab packages from Pune. Travelers can choose temples, beaches, forts, and sightseeing points as per preference. Multi-day itinerary planning support is provided. Pickup and drop timing can be adjusted as required. Suitable for families, groups, and pilgrimage tours. Every trip is planned according to customer convenience."
  },
  {
    "WhyChooseheading": "Comfortable AC Sedan and SUV Fleet",
    "WhyChoosedescription": "Our fleet includes well-maintained AC sedans and spacious SUVs suitable for long-distance travel. Vehicles are cleaned and sanitized before every trip. Comfortable seating ensures relaxed multi-day journeys. SUVs provide extra luggage space for coastal tours. Smooth suspension helps on uneven ghat roads. Travel comfort is never compromised."
  },
  {
    "WhyChooseheading": "Transparent and Fair Pricing",
    "WhyChoosedescription": "We provide complete fare clarity before booking confirmation. Per kilometer rates and driver allowances are clearly explained. No hidden charges or last-minute billing surprises. Toll and parking details are discussed in advance. Customers receive honest and competitive pricing. Affordable travel with full transparency is our commitment."
  },
  {
    "WhyChooseheading": "Safe Coastal and Ghat Driving",
    "WhyChoosedescription": "Konkan routes include hills, sharp turns, and coastal roads requiring skilled driving. Our drivers maintain controlled speed and highway discipline. Vehicles undergo regular servicing and safety checks. Long-distance road travel is handled carefully. Safety measures are strictly followed. You travel with complete peace of mind."
  },
  {
    "WhyChooseheading": "24/7 Booking and Support",
    "WhyChoosedescription": "Our booking support team is available round the clock. Customers can contact us via call, WhatsApp, or online booking. Immediate confirmation and trip coordination are provided. Route guidance and travel queries are addressed promptly. Emergency assistance is available during the journey. Customer satisfaction is always prioritized."
  },
  {
    "WhyChooseheading": "Ideal for Family and Pilgrimage Trips",
    "WhyChoosedescription": "Konkan Darshan trips often include temple visits and beach vacations. Our vehicles are perfect for family groups and senior citizens. Comfortable seating reduces travel fatigue. Drivers assist with temple darshan timing coordination. Safe and patient driving is ensured. Family-friendly service remains our strength."
  },
  {
    "WhyChooseheading": "Multi-Day Tour Expertise",
    "WhyChoosedescription": "We specialize in 2–4 day Konkan coastal tour planning. Drivers stay coordinated throughout the trip duration. Proper rest halts and sightseeing stops are scheduled efficiently. Fuel planning and route optimization are handled professionally. Long-distance travel becomes stress-free. We ensure a smooth and memorable coastal experience."
  }
]

}

const faqData = [
  {
    question: "How many days are ideal for Konkan Darshan from Pune?",
    answer: "Konkan Darshan typically requires 2 to 4 days depending on destinations included. Major places like Ganpatipule, Ratnagiri, and Tarkarli need proper time. We help plan customized itineraries. Multi-day cab packages are available. Flexible scheduling ensures comfortable travel."
  },
  {
    question: "Do you offer one-way Pune to Konkan cab service?",
    answer: "Yes, we provide both one-way and round-trip cab options. Customers can book single drop service as required. Multi-day return packages are also available. Fare details are shared in advance. Transparent pricing is maintained."
  },
  {
    question: "Is SUV recommended for Konkan coastal travel?",
    answer: "SUV vehicles are highly recommended for group and family tours. They provide better stability on ghat roads. Extra luggage space is available. Comfortable seating enhances long journeys. Ideal for multi-day coastal trips."
  },
  {
    question: "Are Konkan Darshan packages customizable?",
    answer: "Yes, our packages are fully customizable. You can choose specific temples, beaches, and sightseeing locations. Pickup timing can be adjusted. Multi-day route planning support is provided. Flexible options ensure convenient travel."
  },
  {
    question: "What is the approximate distance from Pune to Konkan?",
    answer: "The distance depends on the specific destination like Ganpatipule or Ratnagiri. It usually ranges between 300 to 350 km. Travel duration may vary based on traffic and route. We suggest early departures for smooth journeys. Drivers handle route optimization efficiently."
  },
  {
    question: "Do you provide AC vehicles for Konkan tours?",
    answer: "Yes, all our vehicles are air-conditioned. Comfortable cooling is maintained throughout the journey. Sedans and SUVs are available. Vehicles are serviced before long trips. Passenger comfort is ensured."
  },
  {
    question: "Are toll and driver charges included?",
    answer: "We provide clear fare breakdown before booking confirmation. Toll, parking, and driver allowance details are explained. No hidden charges are added later. Transparent billing policy is followed. Customers travel without confusion."
  },
  {
    question: "Is your cab service safe for senior citizens?",
    answer: "Yes, our service is safe and comfortable for senior travelers. Drivers maintain steady driving on ghat roads. Vehicles offer comfortable seating. Temple visit coordination is supported. Family-friendly travel is our priority."
  },
  {
    question: "How can I book Konkan Darshan cab from Pune?",
    answer: "Booking can be done through call or WhatsApp. Online booking assistance is available. Immediate confirmation is provided after schedule discussion. Advance booking is recommended for weekends. Quick support is available 24/7."
  },
  {
    question: "Do you provide same driver for multi-day tours?",
    answer: "Yes, the same assigned driver remains throughout the tour. This ensures better coordination and comfort. Drivers stay informed about your itinerary. Proper rest and travel planning are maintained. Smooth and organized journey is guaranteed."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Prakash Kulkarni",
    feedback: "Our Konkan Darshan trip with Lotus Cab was comfortable and well-coordinated. The driver handled ghat roads very safely. The vehicle was clean and spacious. Pricing was transparent with no hidden charges. Highly recommended for family tours.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Anjali Patil",
    feedback: "We booked a multi-day Konkan tour package and had a smooth experience. The driver was punctual and cooperative. The SUV was perfect for our family. Scenic coastal journey was enjoyable. Excellent service overall.",
    rating: 5
  }
];
















































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Konkan Darshan Cabs",
  "image": "https://lotuscab.com/assets/images/pune-to-konkan-darshan-cabs.jpg", 
  "description": "Lotus Cab offers Pune to Konkan Darshan cabs with affordable packages for coastal trips, temple tours, and family excursions. Book sedan, SUV, and luxury cabs for Ganpatipule, Ratnagiri, Tarkarli, and other Konkan destinations with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Lotus Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "6200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6999",
    "availability": "https://schema.org/InStock",
    "url": "https://lotuscab.com/pune-to-konkan-darshan-cabs"
  }
};









  return (
    <div>
      <Helmet>
  <title>Contact: +91 8767592195 | Pune to Konkan Darshan Cabs | Lotus Cab</title>
  <meta 
    name="description" 
    content="Book Pune to Konkan Darshan cabs with Lotus Cab. Affordable coastal, temple & family trip packages. Call +91 8767592195." 
  />
  <meta 
    name="keywords" 
    content="Pune to Konkan Darshan Cabs, Konkan Darshan Cab Package from Pune, Pune to Konkan Tour Taxi, Konkan Darshan Family Trip Cab, Pune to Konkan Coastal Trip Taxi, Affordable Konkan Darshan Cab Pune, Luxury Cab for Konkan Tour, SUV Taxi Pune to Konkan, Konkan Temple Tour Cab Pune, Online Konkan Darshan Cab Booking, Best Konkan Tour Cab Service Pune, Pune to Ganpatipule Cab, Pune to Ratnagiri Taxi, Pune to Tarkarli Cab Service" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/13.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetokonkandarshancab;